import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!code.trim()) {
      setError("Vul de toegangscode in.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/admin/login", { code: code.trim() });
      navigate("/admin/dashboard");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Onjuiste code. Probeer opnieuw.";
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-[#FF6A1A] flex items-center justify-center p-6">
      <div
        className="w-full max-w-md rounded-3xl border border-[#FF6A1A]/30 p-8 bg-gradient-to-b from-[#1a0e08] to-black shadow-[0_24px_60px_-16px_rgba(255,106,26,0.35)]"
        data-testid="admin-login-card"
      >
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-full bg-[#FF6A1A]/15 border border-[#FF6A1A]/40 flex items-center justify-center">
            <Lock size={18} strokeWidth={2} />
          </div>
          <div>
            <div className="text-[11px] tracking-[0.25em] uppercase font-mono opacity-80">Privé gedeelte</div>
            <div className="font-display text-2xl leading-none mt-1">Admin toegang</div>
          </div>
        </div>

        <p className="text-sm font-medium leading-relaxed opacity-90">
          Voer je persoonlijke toegangscode in om aanmeldingen te beheren.
        </p>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4" data-testid="admin-login-form">
          <label className="block">
            <span className="block text-[11px] tracking-[0.18em] uppercase font-mono opacity-80 mb-2">
              Toegangscode
            </span>
            <input
              type="password"
              autoFocus
              value={code}
              onChange={(e) => setCode(e.target.value)}
              className={`w-full bg-black/40 border ${error ? "border-red-500" : "border-[#FF6A1A]/30"} rounded-xl px-4 py-3 text-base font-medium text-[#FF6A1A] placeholder:text-[#FF6A1A]/40 focus:border-[#FF6A1A] outline-none`}
              placeholder="••••••••••••"
              data-testid="admin-code-input"
            />
          </label>

          {error && (
            <div className="text-red-400 text-sm font-semibold" data-testid="admin-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-[#FF6A1A] text-black font-semibold py-3.5 rounded-full hover:opacity-90 transition-opacity disabled:opacity-50 flex items-center justify-center gap-2"
            data-testid="admin-login-submit"
          >
            {submitting && <Loader2 className="animate-spin" size={16} />}
            <span>{submitting ? "Controleren…" : "Naar Dashboard"}</span>
          </button>
        </form>

        <button
          onClick={() => navigate("/")}
          className="mt-6 w-full text-xs tracking-wide uppercase font-mono opacity-60 hover:opacity-100 transition-opacity"
          data-testid="admin-back-home"
        >
          ← Terug naar website
        </button>
      </div>
    </div>
  );
}
